export default __webpack_public_path__ + "static/media/olivine28.83c2127f.png";